import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CompteRenduService from '../../services/compteRenduService';

const initialState = {
  CompteRendus: [],
  CompteRenduId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements: 0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createCompteRendu = createAsyncThunk(
  'CompteRendu/create',
  async (data, thunkAPI) => {
    try {
      return await CompteRenduService.createCompteRendu(data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllCompteRendu = createAsyncThunk(
  'CompteRendu/getAll',
  async (_, thunkAPI) => {
    try {
      return await CompteRenduService.getAll();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateCompteRendu = createAsyncThunk(
  'CompteRendu/update',
  async ({ id, data }, thunkAPI) => {
    try {
      return await CompteRenduService.updateCompteRendu(id, data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCompteRenduById = createAsyncThunk(
  'CompteRendu/id',
  async (id, thunkAPI) => {
    try {
      return await CompteRenduService.getById(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteCompteRendu = createAsyncThunk(
  'CompteRendu/delete',
  async (id, thunkAPI) => {
    try {
      return await CompteRenduService.DeleteCompteRendu(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const CompteRenduSlice = createSlice({
  name: 'compteRendu',
  initialState,
  reducers: {
    clearCompteRendu: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createCompteRendu.pending, state => {
        state.isLoading = true;
      })
      .addCase(createCompteRendu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) {
          state.CompteRendus.unshift(created);
        }
      })
      .addCase(createCompteRendu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllCompteRendu.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllCompteRendu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.CompteRendus = items;

        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllCompteRendu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateCompteRendu.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateCompteRendu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const updated = action.payload?.result || action.payload?.data || action.payload;
        if (updated?.id) {
          state.CompteRendus = state.CompteRendus.map(item =>
            item.id === updated.id ? { ...item, ...updated } : item
          );
        }
      })
      .addCase(updateCompteRendu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getCompteRenduById.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCompteRenduById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.CompteRenduId = action.payload?.result || action.payload?.data || action.payload;
      })
      .addCase(getCompteRenduById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteCompteRendu.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteCompteRendu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedId = action.payload?.data || action.payload?.id || action.meta.arg;
        state.CompteRendus = state.CompteRendus.filter(item => item.id !== deletedId);
      })
      .addCase(deleteCompteRendu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { clearCompteRendu } = CompteRenduSlice.actions;
export default CompteRenduSlice.reducer;
